app.SettingsDetailsView = app.BaseDetailsView.extend({
  initialize(options) {
    switch (this.model.get('scope')) {
      case 'org':
        options.isReadOnly = !app.sessionUser.isOrgWide();
        break;
      case 'site':
        options.isReadOnly = !app.sessionUser.isSiteWide();
        break;
    }

    app.BaseDetailsView.prototype.initialize.apply(this, [options]);
  },

  _overrideStateIcon(fieldName, modifierClass) {
    const $icon = $(`<div class="field-tooltip override-state-tooltip"></div>`);
    if (modifierClass) {
      $icon.addClass(modifierClass);
    }
    $icon.click(() => {
      this._showOverrideModal(fieldName);
    });
    return $icon;
  },

  _showOverrideModal(fieldName) {
    const detailsView = new app.BiteSettingsFieldInheritanceView({
      model: this.model,
      field: fieldName,
      schema: this.getSchema(),
      isReadOnly: this.isReadOnly,
    });
    this.listenTo(
      detailsView,
      app.BiteSettingsFieldInheritanceView.Events.SettingsWereForced,
      () => {
        this._updateFieldOverrideState();
      },
    );
    this.listenTo(
      detailsView,
      app.BiteSettingsFieldInheritanceView.Events.SettingsWereReset,
      () => {
        // Reset changed this doc's value (to the inherited one), so the field editor must reflect
        // the new value, not just the override badge.
        const fieldView = this.fieldGroupView.fieldViewsByField[fieldName];
        if (fieldView) {
          fieldView.setValue(this.model.get(fieldName), this.model);
        }
        this.fieldGroupView.receiptSampleView?.bindImages();
        this.fieldGroupView.receiptSampleView?.render();
        this._updateFieldOverrideState();
      },
    );
    this.listenTo(detailsView, app.BaseDetailsView.Events.BaseDetailsViewDidClose, () => {
      this.stopListening(detailsView);
    });
    app.modalManager.showModalWithView(detailsView);
  },

  _fieldIsOverriddenByChildren(fieldName) {
    let childSettingsModels;
    switch (this.model.get('scope')) {
      case 'org':
        childSettingsModels = [...(app.allSiteSettings || []), ...(app.allLocationSettings || [])];
        break;
      case 'site':
        childSettingsModels = app.allLocationSettings || [];
        break;
      default:
        // Channel settings have no children
        return false;
    }
    return childSettingsModels.some((childSettingsModel) => {
      return (childSettingsModel.get('overrideSet') || []).includes(fieldName);
    });
  },

  _updateFieldOverrideState() {
    const fieldViewsByField = this.fieldGroupView.fieldViewsByField;

    Object.entries(this.fieldGroupView.fieldViewsByField).forEach(([fieldName, fieldView]) => {
      const $formLabel = fieldView.$el.find('.col-form-label');

      // Re-create the badges on every update since the override state may have changed
      $formLabel.find('.override-state-tooltip').remove();

      // A channel's overrideSet only tracks diffs vs its site; the arrow should also show
      // when the channel matches its site but the site overrides the org
      const overridesParent =
        this.model.overridesField(fieldName) ||
        (this.model.get('scope') === 'channel' && app.siteSettings.overridesField(fieldName));
      const isOverriddenByChildren = this._fieldIsOverriddenByChildren(fieldName);

      const $icons = [];
      if (overridesParent) {
        $icons.push(this._overrideStateIcon(fieldName, 'overrides-parent'));
      }
      if (isOverriddenByChildren) {
        $icons.push(this._overrideStateIcon(fieldName, 'overridden-by-children'));
      }
      if (!$icons.length) {
        $icons.push(this._overrideStateIcon(fieldName, null));
      }
      $icons.reverse().forEach(($icon) => {
        $formLabel.prepend($icon);
      });
    });
  },

  __fieldGroupDidChangeValue() {
    app.BaseDetailsView.prototype.__fieldGroupDidChangeValue.apply(this, arguments);

    this._updateFieldOverrideState();
  },

  _getTabId() {
    return Object.values(this.getSchema().fields)[0].tabId;
  },

  _renderCustomTemplates() {
    if (!app.sessionUser.isBite()) {
      return;
    }

    const tabId = this._getTabId();
    const templatesToPrepend = [];
    if (['receipt-settings-v2', 'sms-settings-v2'].includes(tabId)) {
      templatesToPrepend.push(
        this.valueDisplayTemplate({
          label: 'Notes on Templates:',
          value: `
            The templates below can use the following tokens:
            <br />BRAND_NAME, GUEST_EMAIL, GUEST_NAME, GUEST_PHONE_NUMBER, LOCATION_NAME, LOCATION_PHONE_NUMBER, LOCATION_ADDRESS, ORG_NAME, ORDER_NUMBER, ORDER_PICKUP_TIME, ORDER_TOTAL, ORDER_URL, ORDERED_AT, OUTPOST_NAME, VENDOR_PICKUP_INSTRUCTIONS.
            <br />Consult our client services or eng team for help in setting these up.`,
        }),
      );
    }
    if (templatesToPrepend.length) {
      const $displayGroup = $('<div class="field-group"></div>');
      templatesToPrepend.forEach((template) => {
        $displayGroup.append(template);
      });
      this.$el.prepend($displayGroup);
    }
  },

  render() {
    app.BaseDetailsView.prototype.render.apply(this);

    this._updateFieldOverrideState();

    this._renderCustomTemplates();

    return this;
  },
});
